const textImageVideo = document.querySelectorAll('.text-image__item--has-video');
textImageVideo.forEach((el) => {
  const parentSection = el.closest('.sc-text-image');
  parentSection.classList.add('sc-text-image-video');
});

const floatyImages = document.querySelectorAll('.text-image__image.is-floating')
const animationDuration = 2000;
floatyImages.forEach((floaty) => {
  const randomDuration = Math.floor(Math.random() * animationDuration);
  // eslint-disable-next-line no-param-reassign
  floaty.style.animationDelay = `${randomDuration}ms`;
});
